import React from "react";
import { useNavigate } from "react-router-dom";

import { useMediaQuery } from "@mui/material";

import { Container } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { Button } from "@mui/material";

import ResultColours from "../results/services/ResultColours";
import { animals } from "../results/services/ResultAnimals";
import { QUIZ_LENGTH } from "../..";
import { CustomGrid, classes } from "./style";

export const IntroductionScene = () => {
  const navigate = useNavigate();

  const { colours_main } = ResultColours();

  const meetAnimals = async () => {
    navigate({
      pathname: "/animals",
    });
  };

  const takeQuiz = async () => {
    navigate({
      pathname: "/quiz",
    });

    sessionStorage.setItem("answers", "0".repeat(QUIZ_LENGTH));
    window.location.reload();
  };

  const isMobile = useMediaQuery(
    `(max-width:${localStorage.getItem("SM_SCREEN")})`
  );

  return (
    <CustomGrid
      container
      direction="column"
      alignItems="center"
      justifyContent="flex-start"
      className={classes.root}
    >
      <Container>
        <Grid container className={classes.heading}>
          <Typography
            variant={isMobile ? "h3" : "h2"}
            className={classes.title}
          >
            Welcome to The Career Safari!
          </Typography>
        </Grid>
        <Grid container className={classes.subheading}>
          <Typography variant={isMobile ? "body1" : "h6"}>
            The purpose of The Career Safari is to help you find out what your
            interests are and how they relate to the world of work. Based on the
            Holland Codes, or RIASEC model, the quiz identifies your strengths
            and preferences across six personality types. By answering a list of
            questions designed to understand your areas of interest, you can
            discover your animal type and explore occupations that are a perfect
            fit for you.
          </Typography>
        </Grid>
        <Grid container className={classes.subheading}>
          <Typography variant={isMobile ? "body1" : "h6"}>
            The quiz won’t take more than {QUIZ_LENGTH / 6} minutes to complete.
            Take the time to carefully answer each question on various work
            activities. Try NOT to think about if you have enough
            education/training/experience to do the work or how much money a
            specific occupation might pay.
          </Typography>
        </Grid>
        <Grid container className={classes.animals}>
          {Object.entries(animals).map(([animal, details]) => (
            <Grid
              size={{ xs: 6, md: 4, lg: 2 }}
              className={classes.container}
              key={animal}
            >
              <div className={classes.animalBackground}>
                <div className={classes.imageContainer}>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/animals/${
                      details.name.split(" ")[0]
                    }.png`}
                    loading="lazy"
                    alt={details.name}
                    className={classes.image}
                  ></img>
                </div>
                <div>
                  <Typography
                    variant="h5"
                    className={classes.boldText}
                    sx={{
                      color: colours_main[details.name.split(" ")[0]].colour,
                      paddingBottom: "10px",
                    }}
                  >
                    {details.name}
                  </Typography>
                  <Typography variant="h6">{details.secondaryName}</Typography>
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
        <Grid
          container
          justifyContent="space-evenly"
          style={{ padding: "10px 0px 30px", width: "100%" }}
        >
          <Button
            variant="text"
            color="primary"
            size="large"
            onClick={meetAnimals}
          >
            Meet the animals
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={takeQuiz}
          >
            Take the quiz
          </Button>
        </Grid>
      </Container>
    </CustomGrid>
  );
};

export default IntroductionScene;
